import { type Ref, watch } from "vue";

export function useTypedPhrase(
  phrase: string,
  enabled: Readonly<Ref<boolean>>,
  onMatch: () => void,
): void {
  const expected = phrase.toLowerCase();
  let typed = "";

  function handleKeydown(event: KeyboardEvent): void {
    // Named keys such as Shift have multi-character names, and shortcuts are not typing.
    if (
      event.ctrlKey ||
      event.metaKey ||
      event.altKey ||
      event.key.length !== 1
    ) {
      return;
    }
    typed = (typed + event.key.toLowerCase()).slice(-expected.length);
    if (typed !== expected) return;
    typed = "";
    onMatch();
  }

  watch(
    enabled,
    (listening, _previous, onCleanup) => {
      if (!listening) return;
      typed = "";
      window.addEventListener("keydown", handleKeydown);
      onCleanup(() => window.removeEventListener("keydown", handleKeydown));
    },
    { immediate: true },
  );
}
